import React, {ChangeEvent, Fragment, useRef, useState} from "react";
import "./EV.css";
import axios, {AxiosResponse} from "axios";
import {Col, Row, Form, Button, Modal} from "react-bootstrap";
import {Election} from "./Election";
import Private from "./responses/Private"
import ErrorResponse from "./responses/ErrorResponse";
import {ResponseVoter, Voter} from "./responses/Voter";
import Found from "./responses/Found";
import NotFound from "./responses/NotFound";
import {ObjectMap} from "./ObjectMap";
import {getMessage} from "./util";
import {Helmet} from "react-helmet"

export type ConsultaProps = {
    election: Election
    messages: null | ObjectMap<string>
}

export const Consulta = (props: ConsultaProps) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<string | null>(null);
    const [voter, setVoter] = useState<Voter | null>(null);

    const [runClasses, setRunClasses] = useState<string>("");
    const [run, setRun] = useState<string | undefined>(undefined);

    const site_key: string = process.env.REACT_APP_ENTERPRISE_RECAPTCHA_SITE!;
    const site_key2: string = process.env.REACT_APP_ENTERPRISE_RECAPTCHA_SITE2!;

    const captcha2 = useRef<HTMLDivElement>(null)

    const volver = () => {
        setState(null);
        setVoter(null);
        setRun(undefined);
        setRunClasses("");

    };

    const getDv = (rut: string) => {
        let suma: number = 0;
        for (let i: number = rut.length - 1; i >= 0; i += -1) {
            suma = suma + parseInt(rut.charAt(i), 10) * (2 + (rut.length - 1 - i) % 6);
        }
        suma = 11 - suma % 11;
        switch (suma) {
            case 10:
                return 'K';
            case 11:
                return 0;
            default:
                return suma;
        }
    };

    const validateRut = (rut: string) => {
        var cdv, noFormat;
        noFormat = rut.replace(/[^0-9kK]/g, "").toUpperCase();
        cdv = getDv(noFormat.substring(0, noFormat.length - 1)).toString();
        return noFormat.charAt(noFormat.length - 1).toUpperCase() === cdv.toUpperCase();
    };

    const renderCaptcha = () => {

        if (run == null || !validateRut(run)) {
            setRunClasses("is-invalid");
            return;
        }

        setLoading(true);

        window.grecaptcha.enterprise.render(captcha2.current!, {
            'sitekey': site_key2, 'callback': async (token) => {
                setState(null);
                await connect(encodeURI(run.replace(/\./g, "")), true, token);
                setLoading(false);

            }
        });
    }

    const connect = async (identity: string, rechallenge: boolean, token: string | null) => {

        try {
            const voter: AxiosResponse<ResponseVoter> = await axios({
                method: "post",
                url: process.env.REACT_APP_API_URL + "/election/" + props.election._id +
                    "/voter/" + identity,
                data: {
                    recaptcha: token,
                    rechallenge: rechallenge
                }
            });

            if (voter.data.state === 'ok') {
                setVoter(voter.data.voterInfo!);
            }

        } catch (error) {
            switch (error.response.status) {
                case 400:
                    if (error.response.data && error.response.data.state === 'captcha') {
                        setLoading(false);
                        if (rechallenge)
                            setState("nocaptcha");
                        else
                            setState("captcha");
                        break;
                    }
                    setState("error");
                    break
                case 401:
                    setState("unpublish");
                    break
                case 404:
                    setState("notfound");
                    break
                default:
                    setState("error");
                    break
            }


        } finally {
            setLoading(false);
        }
    }

    const clean = () => {
        setRun(undefined);
        setState(null);
        setRunClasses("");
        setLoading(false);
    }

    const loadVoter = async () => {

        if (run == null ) {
            setRunClasses("is-invalid");
            return;
        }


        let cleanRun = run

        switch (props.election.configuration.identification_field.split('+', 2)[0]) {
            case 'run':
                cleanRun = run.replace(/\./g, "").trim();
                if (!validateRut(cleanRun)) {
                    setRunClasses("is-invalid");
                    return;
                }
                break;
            case 'email':
                cleanRun = run.trim();
                break;
            default:
                cleanRun = run.trim();
                break;
        }

        setLoading(true);


        if (props.election.configuration.advanced_config.captcha) {
            window.grecaptcha.enterprise.ready(async () => {
                window.grecaptcha.enterprise.execute(site_key, {action: 'ask_data'}).then(token => {
                    connect(encodeURI(cleanRun),false, token);
                })
            })
        } else {
            await connect(encodeURI(cleanRun), false, null);
        }
        setLoading(false);

    };


    const verifyAndFixRut = (target: any) => {
        var cdv, dv, noFormat, rut, withFormat;


        noFormat = target.value.replace(/[^0-9kK]/g, "").toUpperCase();
        dv = noFormat.charAt(noFormat.length - 1);
        rut = noFormat.substring(0, noFormat.length - 1);
        withFormat = '';
        while (rut.length > 3) {
            withFormat = "." + rut.substr(rut.length - 3) + withFormat;
            rut = rut.substring(0, rut.length - 3);
        }
        withFormat = rut + withFormat + "-" + dv.toUpperCase();
        if (noFormat.length > 1) {
            target.value = withFormat;
        } else {
            target.value = noFormat;
        }
        cdv = getDv(noFormat.substring(0, noFormat.length - 1)).toString();
        if (dv.toUpperCase() === cdv.toUpperCase()) {
            setRunClasses("is-valid");
            setRun(withFormat);
        } else {
            setRunClasses("");
            setRun(withFormat);
        }
    };


    const handleRutInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        verifyAndFixRut(event.currentTarget);
    };

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setRun(event.currentTarget.value.trim());
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && event.shiftKey === false) {
            event.preventDefault();
        }
    };


    return (

        <Fragment>
            <Modal show={state === 'captcha'} onHide={clean} onEntered={renderCaptcha}>
                <Modal.Header closeButton>
                    <Modal.Title>{getMessage('captcha_title', props.messages)}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className={"lead"}>{getMessage('captcha.try.message', props.messages)}</p>
                    <div ref={captcha2}></div>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                            onClick={clean}>{getMessage('close', props.messages)}</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={state === 'nocaptcha'} onHide={clean} >
                <Modal.Header closeButton>
                    <Modal.Title>{getMessage('captcha_title', props.messages)}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className={"lead"}>{getMessage('captcha.fail.message', props.messages)}</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary"
                            onClick={clean}>{getMessage('close', props.messages)}</Button>
                </Modal.Footer>
            </Modal>

            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>
                    <h3>{props.election.name}
                        <br/> <small>
                        {props.election.organization_name}
                    </small></h3>

                </Col>
            </Row>

            {state === "unpublish" && <Private messages={props.messages} election={props.election}/>}
            {state === "error" && <ErrorResponse messages={props.messages} volver={volver}/>}
            {state === "notfound" && <NotFound messages={props.messages} volver={volver}/>}
            {voter && <Found messages={props.messages} election={props.election} voter={voter} volver={volver}/>}


            {props.election.configuration.advanced_config.captcha &&
            <Helmet>
                <script src={"https://www.google.com/recaptcha/enterprise.js?render=" + site_key}></script>
            </Helmet>
            }

            {!(state || voter) &&
            <Row className={"justify-content-center"}>
                <Col xs={12} sm={11} md={9} lg={7}>

                    {loading ? (
                        <div className={"spinner"}/>
                    ) : (<Form>
                        <Form.Group controlId="run">
                            <Form.Label className="my-4">
                                Ingrese su RUN y presione el botón "Consultar" para revisar si puede participar de la consulta:
                            </Form.Label>
                            <Form.Control onChange={handleRutInputChange} type="text" name="run"
                                          onKeyDown={handleKeyDown}
                                          placeholder="Ej: 12345678-9" maxLength={12} className={runClasses}/>
                            <Form.Control.Feedback type="invalid">
                                {getMessage('wrong_id', props.messages)}
                            </Form.Control.Feedback>
                        </Form.Group>
                        <br/>
                        <Row>
                            <Col sm={6} className={"text-right"}>
                                <Button className="EvColorBlue text-white m-1" onClick={loadVoter}
                                        variant="primary">{getMessage('ask_button', props.messages)}</Button>
                                <Button className="EvColorGrisLight m-1"
                                        href={props.election.configuration.home_url}
                                        variant="light">{getMessage('exit_button', props.messages)}</Button>
                            </Col>
                        </Row>
                    </Form>)}
                </Col>
            </Row>}

        </Fragment>
    );

}

export default Consulta;
